import { rtLogService } from '@rammetec/core';
import { repositoryResolver } from '@rammetec/data-access';
import { WAREHOUSE_MAP } from '../types/warehouse-map.js';
import { auditService } from './auditService.js';
/**
 * Org-scoped warehouse text → StockLocation map (0111).
 * Business key: warehouseCode (trimmed, case-sensitive as on the invoice).
 */
class WarehouseMapService {
    getRepo(orgId) {
        return repositoryResolver.resolveWithContext(WAREHOUSE_MAP, { orgId });
    }
    async getAll(orgId) {
        const repository = await this.getRepo(orgId);
        return repository.getAll();
    }
    async findByCode(orgId, warehouseCode) {
        const code = warehouseCode.trim();
        if (!code)
            return null;
        const all = await this.getAll(orgId);
        return all.find((r) => r.warehouseCode === code) ?? null;
    }
    async upsert(orgId, input) {
        const warehouseCode = input.warehouseCode.trim();
        const stockLocationId = input.stockLocationId.trim();
        if (!warehouseCode || !stockLocationId) {
            throw new Error('warehouseCode e stockLocationId são obrigatórios.');
        }
        try {
            const repository = await this.getRepo(orgId);
            const all = await repository.getAll();
            const existing = all.find((row) => row.warehouseCode === warehouseCode);
            const now = new Date();
            if (existing) {
                const patch = auditService.stampOnUpdate({
                    stockLocationId,
                    lastUsedAt: now,
                });
                await repository.update(existing.id, patch);
                const updated = await repository.getById(existing.id);
                rtLogService.info('WarehouseMap updated', { orgId, id: existing.id, warehouseCode });
                return updated ?? { ...existing, ...patch, id: existing.id };
            }
            const created = await repository.create(auditService.stampOnCreate({
                id: crypto.randomUUID(),
                warehouseCode,
                stockLocationId,
                lastUsedAt: now,
            }));
            rtLogService.info('WarehouseMap created', { orgId, id: created.id, warehouseCode });
            return created;
        }
        catch (error) {
            rtLogService.error('Error upserting WarehouseMap', { orgId, warehouseCode, error });
            throw error;
        }
    }
    async delete(orgId, id) {
        const repository = await this.getRepo(orgId);
        await repository.delete(id);
        rtLogService.info('WarehouseMap deleted', { orgId, id });
    }
}
export const warehouseMapService = new WarehouseMapService();
//# sourceMappingURL=warehouseMapService.js.map